import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { buildingBlocks } from '../../data/content';
import { IMAGES } from '../../data/site';
import { SectionCTA } from '../SectionCTA';
export function CreatorApproach() {
  return <section className="w-full bg-white px-4 py-16 sm:px-6 sm:py-20" data-id="element-142" data-mp="1v2x4842f8sx">
      <div className="mx-auto max-w-5xl" data-id="element-143" data-mp="6tw0h7pn1jfd">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.18em] text-ink-muted" data-id="element-144" data-mp="6skx3903udos">
          Created by Dr. Karito
        </p>
        <h2 className="mx-auto mt-3 max-w-2xl text-center font-display text-3xl font-bold leading-tight text-ink sm:text-4xl" data-id="element-145" data-mp="3t2f6i0ypihya">
          A practical approach to building a repeatable clinical workflow
        </h2>

        <div className="mt-10 grid items-start gap-8 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)]" data-id="element-146" data-mp="3k28vclqhdu2a">
          <figure className="mx-auto w-full max-w-sm" data-id="element-147" data-mp="1dbsur2ufasax">
            <img src={IMAGES.author} alt="Dr. Karito, dentist and creator of the DVO Clinical Workflow Builder, in her clinic" className="w-full rounded-3xl object-cover shadow-lift" data-id="element-148" data-mp="1i9udfmnxsplv" />
            <figcaption className="mt-3 text-center text-xs leading-relaxed text-ink-muted" data-id="element-149" data-mp="1v0eexiva2gxm">
              Dr. Karito, dentist and creator of the DVO Clinical Workflow Builder™, in her clinic
            </figcaption>
          </figure>

          <div className="space-y-4 text-[15px] leading-relaxed text-ink-soft" data-id="element-150" data-mp="23vudgd6z9k9j">
            <p data-id="element-151" data-mp="1g4owtvt7qny6">
              After years of studying, teaching and working with complex restorative and
              rehabilitation cases, Dr. Karito recognized a recurring problem among dentists:
            </p>
            <p className="font-semibold text-ink" data-id="element-152" data-mp="1q09trfjfcy12">They didn’t need another lecture.</p>
            <p data-id="element-153" data-mp="1l1ow9nvk4sgb">
              They needed a way to turn their existing clinical knowledge into a structured
              sequence they could return to every time a complex case appeared.
            </p>
            <p data-id="element-154" data-mp="2wi6sbmv8st2f">
              That’s why she created the{' '}
              <strong className="font-bold text-navy-600" data-id="element-155" data-mp="34jwag57nn5lj">DVO Clinical Workflow Builder™</strong>.
              Instead of another traditional textbook or lengthy course, the material is structured
              around six practical building blocks:
            </p>

            <ul className="grid grid-cols-2 gap-2.5 pt-1" data-id="element-156" data-mp="3iivu0ygb8uau">
              {buildingBlocks.map(block => <li key={block} className="rounded-xl border border-navy-100 bg-cream px-3.5 py-2.5 text-[13.5px] font-bold text-navy-700" data-id="element-157" data-mp="2kvf3tyucbm8q">
                  {block}
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mx-auto mt-10 flex max-w-3xl flex-col items-center gap-2.5 sm:flex-row sm:justify-between" data-id="element-158" data-mp="2zjrrm8j9xys5">
          {['Scattered information', 'Structured workflow', 'Repeatable case organization'].map((stage, i) => <React.Fragment key={stage} data-id="element-159" data-mp="2725yc99ijkvh" data-mpi={i}>
                {i > 0 && <ArrowRightIcon className="h-4 w-4 shrink-0 rotate-90 text-navy-400 sm:rotate-0" aria-hidden="true" data-id="element-160" data-mp="1zkhf7tgagiyh" />}
                <span className={`w-full rounded-xl px-4 py-3 text-center text-[12.5px] font-extrabold uppercase tracking-[0.08em] sm:w-auto sm:flex-1 ${i === 2 ? 'bg-go text-white' : i === 1 ? 'bg-navy-600 text-white' : 'bg-sand text-ink-soft'}`} data-id="element-161" data-mp="1pl8qbf0a5uiz">
                  {stage}
                </span>
              </React.Fragment>)}
        </div>

        <SectionCTA transformation="Six building blocks instead of one more lecture." label="Get the Workflow Builder™" subline="Instant access · Lifetime reference" data-id="element-162" data-mp="11y0jutr48ffd" />
      </div>
    </section>;
}